import React, { useEffect, useState } from 'react';
import LcLoading from '../../../../components/Generic/LcLoading';
import ReactECharts from 'echarts-for-react';
import { FinOpsChartService } from '../../../../services/finOps/finOpsChartService';
import { PatchManagerService } from '../../../../services/patchmanager/patchManagerService';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import LcNoData from '../../../../components/Generic/LcNoData';
import { GraphModel } from '../../../../services/patchmanager/patchManagerModel';

export interface DoughNutModel {
    value: number;
    name: string;
    itemStyle?: object;
}

const InstalledVsMissingGraph: React.FC = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);

    const finOpsChartService: FinOpsChartService = (new FinOpsChartService(props));
    const patchManagerService = new PatchManagerService(props);
    const [patchInfoGraph, setPatchInfoGraph] = useState<DoughNutModel[]>([])
    const [loading, setLoading] = useState<boolean>(false);

    const getDataGraph = async () => {
        try {
            const patchesResponse = await patchManagerService.GetPatchSummariesInstalledVsMissing();            
            setPatchInfoGraph(buildDataGraph(patchesResponse));
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const getColorsGraph = (SOName: string): string => {
        const color = {
            'Ausentes': '#ffa400',
            'Instalados': "#3ebb3f",
        };
        return color[SOName];
    }

    const buildDataGraph = (data: GraphModel[]) => {
        return data.map(graph => {
            return {
                value: graph.value,
                name: graph.name,
                itemStyle: { color: getColorsGraph(graph.name) }
            }
        })
    }

    useEffect(() => {
        setLoading(true)
        getDataGraph()
            .finally(() => setLoading(false))
    }, [user.ClientGroupSelected, user.refreshFlag])


    const data = [
        { value: 333, name: 'Ausentes', itemStyle: { color: getColorsGraph('Ausentes') } },
        { value: 1069, name: 'Instalados', itemStyle: { color: getColorsGraph('Instalados') } },
    ]

    return (
        <LcLoading loading={loading} label="Carregando gráfico...">
            {
                patchInfoGraph.length > 0 ?
                    <ReactECharts
                        opts={{ renderer: 'svg', locale: 'PT-br' }}
                        className='InstalledVsMissingGraph'
                        option={finOpsChartService.getDougnutChartWithLegend(patchInfoGraph)}
                    />
                    :
                    <LcNoData size="small" />

            }
        </LcLoading>
    );
}

export default InstalledVsMissingGraph;